import { apiClient } from "../../services/apiService";

export type SupportTicketStatus = "OPEN" | "REPLIED" | "RESOLVED" | "CLOSED";

/** Mirrors the backend SupportTicket JSON (camelCase, author derived getters). */
export interface SupportTicket {
  id: number;
  subject?: string | null;
  category?: string | null;
  bodyText: string;
  status: SupportTicketStatus;
  adminReply?: string | null;
  replyChannels?: string | null;
  createdAt?: string;
  updatedAt?: string;
  repliedAt?: string | null;
  resolvedAt?: string | null;
  // Derived author fields (admin inbox rendering).
  createdUserId?: number | null;
  createdUserEmail?: string | null;
  createdUserHandle?: string | null;
  createdUserPicture?: string | null;
  createdUserFirstname?: string | null;
  createdUserLastname?: string | null;
}

export interface SubmitSupportTicketBody {
  subject?: string;
  category?: string;
  bodyText: string;
}

const BASE = "/api/v1/support";

/** Submit a new support request (logged-in members only). */
export const submitSupportTicket = async (
  body: SubmitSupportTicketBody
): Promise<SupportTicket> => {
  const { data } = await apiClient.post(`${BASE}/tickets`, body);
  return data;
};

/** The caller's own tickets, newest first. */
export const getMySupportTickets = async (): Promise<SupportTicket[]> => {
  const { data } = await apiClient.get(`${BASE}/tickets`);
  return Array.isArray(data) ? data : [];
};
